import { RootState } from '../store';

export const selectJobTypeOptions = (state: RootState) => state.jobType.jobTypeOptions;

export const selectJobTypeOptionsRequestStatus = (state: RootState) => state.jobType.jobTypeOptionsRequestStatus;
